import { useBack } from "@website/hooks/back";
import { useState } from "react";

export const useSupportMenu = () => {
  //TODO: need changes
  const { goBack } = useBack();
  const [supportMenuIsOpen, setSupportMenuIsOpen] = useState<boolean>(false);

  const onSupportMenuOpen = () => {
    setSupportMenuIsOpen(true);
  };

  const onSupportMenuClose = () => {
    setSupportMenuIsOpen(false);
  };

  return {
    onSupportMenuOpen,
    onSupportMenuClose,
    supportMenuIsOpen,
    onGoBack: goBack
  };
};
